import { avSettingKeys } from './constants'

import { createEventEmitter } from '../event'

export const avSettingEventEmitter = createEventEmitter()

export const emitOpenAVSettings = value => {
    avSettingEventEmitter.emit(avSettingKeys.OPEN_AV_SETTINGS, value)
}
